<template>
  <div class="selectEngineerList">
    <div class="totalCount">金额总计：{{projectDetailsTotalPrice}}</div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      size="mini"
      style="width: 100%; margin-top: 20px"
      height="100%"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.isNumFilter">{{
            scope.row[scope.column.property] | numFilter
          }}</span>
          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="totalCount"
      ></el-pagination>
    </el-footer>
  </div>
</template>

<script>
import { accMul, numFilter } from "@/utils/filters";
export default {
  name: "selectEngineerList",
  props: {
    engineerItems: {
      type: Array,
    },
    projectDetailsTotalPrice:{
      type:Number,
      default:null
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      tableData:[],
      tableColumnDatas: [
        // { class: "subCategoryNo", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "子目号", sortEnable: false },
        { class: "subCategoryName", labelName: "子目名称", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "unitPrice",
          labelName: "单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        // { class: "comments", labelName: "备注", sortEnable: false }
      ],
    };
  },
  mounted() {
    this.initList();
  },
  watch: {
    engineerItems(newVal) {
      if (newVal.length > 0) {
        this.initList();
      }
    },
    projectDetailsTotalPrice(newVal){
      if (newVal) {
       console.log(newVal)
      }

    },
  },
  methods: {
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.pageSize = rows;
      this.pageIndex = 1;
      //  this.selectsubItems.length=0;
      this.initList();
    },
    initList() {
      this.totalCount = this.engineerItems.length;
      this.tableData = this.engineerItems.slice(
        this.pageSize * (this.pageIndex - 1),
        this.pageSize * this.pageIndex
      );
    },
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" || column.property == "totalPrice")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            // curr.replace(/,/g, "")
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == "quantity") {
            sums[index] += "";
          } else {
            sums[index] = numFilter(sums[index]);
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>
<style scoped >
/deep/.el-tabs__item {
  height: 56px;
  line-height: 56px;
  width: 160px;
  padding: 0 !important;
  font-size: 18px;
  color: #666666 !important;
}
/deep/.el-tabs__header {
  padding-right: 0;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
  padding: 0;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.selectEngineerList {
  /deep/.el-table__body-wrapper {
    height: auto !important;
  }
  .totalCount{
    width: 100%;
    text-align: right;
    margin-top: 20px;
  }
}
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
